import React from 'react';
import { Calendar, Tag } from 'lucide-react';
import { Card } from '../components/ui/card';

const Events = () => {
  return (
    <div className="bg-white min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 md:py-32">
        <div className="max-w-[87.5rem] mx-auto px-5 md:px-10">
          <h1 className="font-black text-5xl md:text-8xl leading-[0.76] text-[#0A277A] uppercase mb-8">
            Events & News
          </h1>
          <p className="text-gray-700 text-xl md:text-2xl max-w-3xl leading-relaxed">
            Stay tuned for upcoming events and news from the MOS community.
          </p>
        </div>
      </section>

      {/* Pending Events Section */}
      <section className="py-16">
        <div className="max-w-[87.5rem] mx-auto px-5 md:px-10">
          <div className="text-center mb-16">
            <h2 className="font-black text-4xl md:text-6xl text-[#0A277A] uppercase mb-4">
              Upcoming Events
            </h2>
            <p className="text-gray-600 text-lg mb-8">
              Pending
            </p>
          </div>

          <div className="max-w-2xl mx-auto text-center">
            <Card className="bg-gray-50 border-2 border-[#3F54C8] p-12">
              <div className="text-[#3F54C8] mb-4">
                <Calendar size={64} className="mx-auto" />
              </div>
              <h3 className="font-black text-2xl text-[#0A277A] uppercase mb-4">
                Events Coming Soon
              </h3>
              <p className="text-gray-700 leading-relaxed">
                We're planning community gatherings, networking events, and information sessions for the veteran community. Check back soon for our event calendar.
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* Pending News Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-[87.5rem] mx-auto px-5 md:px-10">
          <div className="text-center mb-16">
            <h2 className="font-black text-4xl md:text-6xl text-[#0A277A] uppercase mb-4">
              Latest Updates
            </h2>
            <p className="text-gray-600 text-lg mb-8">
              Pending
            </p>
          </div>

          <div className="max-w-2xl mx-auto text-center">
            <Card className="bg-white border-2 border-[#D80000] p-12">
              <div className="text-[#D80000] mb-4">
                <Tag size={64} className="mx-auto" />
              </div>
              <h3 className="font-black text-2xl text-[#0A277A] uppercase mb-4">
                News & Updates Coming Soon
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Stay connected for the latest news, success stories, and announcements from MOS Veteran. Subscribe to our newsletter to be the first to know.
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-5 md:px-10 text-center">
          <Card className="bg-[#3f4816] border-none p-12">
            <h2 className="font-black text-3xl md:text-5xl text-[#0A277A] uppercase mb-4">
              Never Miss an Update
            </h2>
            <p className="text-gray-800 text-lg mb-8">
              Subscribe to our newsletter for cohort announcements, success stories, and event invitations.
            </p>
            <a href="/#newsletter" className="inline-block">
              <button className="bg-[#D80000] text-[#1a1c1b] px-10 py-4 rounded-full font-semibold uppercase hover:opacity-90 transition-all hover:scale-105">
                Subscribe Now
              </button>
            </a>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Events;